/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateProductDto
 */
export interface CreateProductDto {
    /**
     * Product SKU (Stock Keeping Unit)
     * @type {string}
     * @memberof CreateProductDto
     */
    sku: string;
    /**
     * Product name in Arabic
     * @type {string}
     * @memberof CreateProductDto
     */
    nameAr: string;
    /**
     * Product name in English
     * @type {string}
     * @memberof CreateProductDto
     */
    nameEn: string;
    /**
     * Product description in Arabic
     * @type {string}
     * @memberof CreateProductDto
     */
    descriptionAr?: string;
    /**
     * Product description in English
     * @type {string}
     * @memberof CreateProductDto
     */
    descriptionEn?: string;
    /**
     * Array of product image URLs
     * @type {Array<string>}
     * @memberof CreateProductDto
     */
    imageUrls?: Array<string>;
    /**
     * Whether product is in stock
     * @type {boolean}
     * @memberof CreateProductDto
     */
    inStock?: boolean;
    /**
     * Brand code from brand lookup table
     * @type {string}
     * @memberof CreateProductDto
     */
    brandCode: string;
    /**
     * Category code from category lookup table
     * @type {string}
     * @memberof CreateProductDto
     */
    categoryCode: string;
    /**
     * Sub-brand code from sub-brand lookup table
     * @type {string}
     * @memberof CreateProductDto
     */
    subBrandCode: string;
    /**
     * Sub-category code from sub-category lookup table
     * @type {string}
     * @memberof CreateProductDto
     */
    subCategoryCode: string;
    /**
     * Product barcode
     * @type {string}
     * @memberof CreateProductDto
     */
    barcode?: string;
    /**
     * Product prices in different currencies
     * @type {Array<object>}
     * @memberof CreateProductDto
     */
    prices: Array<object>;
    /**
     * Tax rate as percentage (0-100)
     * @type {number}
     * @memberof CreateProductDto
     */
    taxRate?: number;
    /**
     * Discount rate as percentage (0-100)
     * @type {number}
     * @memberof CreateProductDto
     */
    discountRate?: number;
    /**
     * Product length in centimeters
     * @type {number}
     * @memberof CreateProductDto
     */
    length?: number;
    /**
     * Product width in centimeters
     * @type {number}
     * @memberof CreateProductDto
     */
    width?: number;
    /**
     * Product height in centimeters
     * @type {number}
     * @memberof CreateProductDto
     */
    height?: number;
    /**
     * Product weight in kilograms
     * @type {number}
     * @memberof CreateProductDto
     */
    weight?: number;
    /**
     * Whether product is disabled
     * @type {boolean}
     * @memberof CreateProductDto
     */
    disabled?: boolean;
}

/**
 * Check if a given object implements the CreateProductDto interface.
 */
export function instanceOfCreateProductDto(value: object): value is CreateProductDto {
    if (!('sku' in value) || value['sku'] === undefined) return false;
    if (!('nameAr' in value) || value['nameAr'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('brandCode' in value) || value['brandCode'] === undefined) return false;
    if (!('categoryCode' in value) || value['categoryCode'] === undefined) return false;
    if (!('subBrandCode' in value) || value['subBrandCode'] === undefined) return false;
    if (!('subCategoryCode' in value) || value['subCategoryCode'] === undefined) return false;
    if (!('prices' in value) || value['prices'] === undefined) return false;
    return true;
}

export function CreateProductDtoFromJSON(json: any): CreateProductDto {
    return CreateProductDtoFromJSONTyped(json, false);
}

export function CreateProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProductDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sku': json['sku'],
        'nameAr': json['nameAr'],
        'nameEn': json['nameEn'],
        'descriptionAr': json['descriptionAr'] == null ? undefined : json['descriptionAr'],
        'descriptionEn': json['descriptionEn'] == null ? undefined : json['descriptionEn'],
        'imageUrls': json['imageUrls'] == null ? undefined : json['imageUrls'],
        'inStock': json['inStock'] == null ? undefined : json['inStock'],
        'brandCode': json['brandCode'],
        'categoryCode': json['categoryCode'],
        'subBrandCode': json['subBrandCode'],
        'subCategoryCode': json['subCategoryCode'],
        'barcode': json['barcode'] == null ? undefined : json['barcode'],
        'prices': json['prices'],
        'taxRate': json['taxRate'] == null ? undefined : json['taxRate'],
        'discountRate': json['discountRate'] == null ? undefined : json['discountRate'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
    };
}

export function CreateProductDtoToJSON(value?: CreateProductDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sku': value['sku'],
        'nameAr': value['nameAr'],
        'nameEn': value['nameEn'],
        'descriptionAr': value['descriptionAr'],
        'descriptionEn': value['descriptionEn'],
        'imageUrls': value['imageUrls'],
        'inStock': value['inStock'],
        'brandCode': value['brandCode'],
        'categoryCode': value['categoryCode'],
        'subBrandCode': value['subBrandCode'],
        'subCategoryCode': value['subCategoryCode'],
        'barcode': value['barcode'],
        'prices': value['prices'],
        'taxRate': value['taxRate'],
        'discountRate': value['discountRate'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'weight': value['weight'],
        'disabled': value['disabled'],
    };
}

